<script>
  import { onMount } from "svelte";
  import { fetchWithSession } from "lib/util/fetchWithSession.js";
  import { projectListStore } from "@stores/damProjectsStore.js";
  import { useUrlParams } from "@stores/urlStore.js";
  import { applicationLimitationStore } from "@stores/applicationLimitationStore.js";
  import {
    DataTable,
    Toolbar,
    ToolbarContent,
    ToolbarSearch,
    ToolbarBatchActions,
    MultiSelect
} from "carbon-components-svelte";

  import LimitationList from "../components/LimitationList.svelte";
  import { Pagination, TextArea, SectionWrapper, Button } from "paxray-components-svelte";

  import { formatTimeDelta } from "lib/util/formatfunctions.js";

  import ContentSwitcherNew from "../../../../lib/components/ContentSwitcher.svelte";

  export let isCompleted = false;

  const { updateProjectStep } = projectListStore;
  const urlParams = useUrlParams();

  let teamids = [];

  let idLimitation = 0;
  let selectedRowIds = [];
  let addedApplications = [];
  let overviewloading = true;
  // let overviewkpipromise = getAppOverviewKPIs();
  let webapploading = true;
  let sortKey = "time";
  let sortDirection = "descending";
  let overview = [];
  let webapps = [];
  let isWebApp = 0;
  let appsPage = 1;
  let webPage = 1;
  let message = "";
  let confirmmessage = "";
  let switcherOptions = ["Desktop Applications", "Web Applications"];
  let teams = [];
  let teamsweb = [];
  let teamIds = new Set();
  let teamsIdsWeb = new Set();
  let originalOverview = [];
  let originalWebapps = [];
  let applicationLimitations = [];
  let firstTime = true;

  $: ({ idproject, currentStep } = $urlParams);

  $: ({ applicationLimitations } = $applicationLimitationStore);

  $: if (idproject) {
    loadProjectData();
  }
  $: {
    if (applicationLimitations.length > 0 && firstTime) {
      selectedRowIds = getSelected(isWebApp);
      firstTime = false;
    }
  }

  $: {
    if (teamids.length > 0) {
      if (isWebApp) {
        webapps = originalWebapps.filter((webapp) =>
          webapp.teamlist.some((team) => teamids.includes(team.id)),
        );
      } else {
        overview = originalOverview.filter((app) =>
          app.teamlist.some((team) => teamids.includes(team.id)),
        );
      }
    } else {
      overview = [...originalOverview];
      webapps = [...originalWebapps];
    }
  }

  $: {
    selectedRowIds = getSelected(isWebApp);
  }

  async function getAppOverview() {
    overviewloading = true;
    webapploading = true;
    const res = await fetchWithSession(
      `/api/damprojects/AppOverview?idproject=${idproject}&projectStep=0`,
    );
    const text = await res.json();
    const { appOverview, webAppOverview } = text;
    overview = appOverview;
    webapps = webAppOverview;
    originalOverview = [...overview];
    originalWebapps = [...webapps];
    overview.forEach((app) => {
      app.teamlist.forEach((team) => {
        if (!teamIds.has(team.id)) {
          teamIds.add(team.id);
          teams.push({ id: team.id, text: team.name });
        }
      });
    });
    teams = teams;
    webapps.forEach((app) => {
      app.teamlist.forEach((team) => {
        if (!teamsIdsWeb.has(team.id)) {
          teamsIdsWeb.add(team.id);
          teamsweb.push({ id: team.id, text: team.name });
        }
      });
    });
    teamsweb = teamsweb;
    overviewloading = false;
    webapploading = false;
    selectedRowIds = getSelected(isWebApp);
    if (res.ok) {
      return text;
    } else {
      throw new Error(text);
    }
  }

  function startAnonymizationRecording() {
    fetchWithSession(`/api/damprojects/startAnonymizationRecording`, {
      method: "POST",
      body: JSON.stringify({
        idproject: idproject,
        message: message,
        confirmmessage: confirmmessage,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        fetchWithSession(
          `/api/damprojects/completeDAMProjectStep/${idproject}/1`,
          {
            method: "POST",
          },
        )
          .then((res) => res.json())
          .then((data) => {
            if (data.success) {
              isCompleted = true;
              currentStep += 1;
              updateProjectStep(idproject, currentStep);
            }
          });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function addWebApplications() {
    let newAppclications = [];
    webapps.forEach((webapp) => {
      if (selectedRowIds.includes(webapp.id)) {
        newAppclications.push({
          id: 0,
          isbrowser: 1,
          name: webapp.url,
          appname: "",
          url: webapp.url,
          windowtitle: "",
        });
      }
    });
    addedApplications = newAppclications;
    selectedRowIds = [];
  }

  function addDesktopApplications() {
    let newAppclications = [];
    overview.forEach((app) => {
      if (selectedRowIds.includes(app.id)) {
        newAppclications.push({
          id: 0,
          isbrowser: 0,
          name: app.applicationname,
          appname: app.applicationname,
          windowtitle: "",
          url: "",
        });
      }
    });
    addedApplications = newAppclications;
    selectedRowIds = [];
  }

  function getSelected(isWebApp) {
    const applist = applicationLimitations.map((app) => app.name);
    let selected = [];
    if (isWebApp) {
      webapps.forEach((app) => {
        if (applist.includes(app.url)) {
          selected.push(app.id);
        }
      });
      return selected;
    } else {
      overview.forEach((app) => {
        if (applist.includes(app.applicationname)) {
          selected.push(app.id);
        }
      });
      return selected;
    }
  }

  function loadProjectData() {
    fetchWithSession(`/api/damprojects/getProjectLimitations/${idproject}/1`)
      .then((res) => res.json())
      .then((data) => {
        idLimitation = data;
      });
    getAppOverview();
  }
</script>

<SectionWrapper fullscreen={true}>
  <div class="main" slot="main">
    <div class="table_heading info_wrapper">
      <!-- @Adrian hier bitte ergänzen, was genau hier passiert -->
      <h5>Application Scope</h5>
      <div class="info">
        Here you can see the applications that are currently being used by the
        recorded teams. <br />
        Select all relevant applications and add them to a whitelist for best results.
      </div>
    </div>

    <div class="table_heading">
      <h5>Log Overview</h5>
      <div class="info">
        Here you can see an overview of the collected data.
      </div>
    </div>
    <!-- {#await overviewkpipromise}
        Loading
      {:then overviewkpis}
        <div class="barchart_wrapper">
          <BarChart
            horizontal
            label="Time Per Application"
            height="300px"
            width="33%"
            data={sort_object(overviewkpis.time)}
            bind:highlight={currentApp}
          ></BarChart>
          <BarChart
            horizontal
            label="# of Keystrokes"
            height="300px"
            width="33%"
            data={sort_object(overviewkpis.keystrokes)}
            bind:highlight={currentApp}
          ></BarChart>
          <BarChart
            horizontal
            label="# of Mouse Clicks"
            height="300px"
            width="33%"
            data={sort_object(overviewkpis.mouseclicks)}
            bind:highlight={currentApp}
          ></BarChart>
        </div>
      {/await} -->

    <div class="table_heading">
      <h5>Application Details</h5>
      <div class="info">
        Here you can see more details for a specific application.
      </div>
    </div>

    <div class="content_wrapper">
      <ContentSwitcherNew options={switcherOptions} bind:selected={isWebApp} />
      <MultiSelect
        titleText="Teams"
        bind:selectedIds={teamids}
        label="Select a team"
        items={isWebApp ? teamsweb : teams}
      />

      {#if isWebApp}
        {#if webapploading}
          Loading
        {:else}
          <div class="table_wrapper">
            <DataTable
              size="short"
              headers={[
                { key: "url", value: "Application" },
                { key: "clearname", value: "Clearname" },
                { key: "time", value: "Time" },
                { key: "keystrokes", value: "Keystrokes" },
                { key: "mouseclicks", value: "Mouseclicks" },
                { key: "nteams", value: "Teams" },
              ]}
              rows={webapps}
              sortable
              bind:sortKey
              bind:sortDirection
              batchSelection
              bind:selectedRowIds
              pageSize={10}
              page={webPage}
            >
              <Toolbar size="sm">
                <ToolbarBatchActions>
                  <Button
                    on:click={addWebApplications}
                    text=">> Add Selected to Limitations"
                    kind="secondary"
                  />
                </ToolbarBatchActions>
                <ToolbarContent>
                  <ToolbarSearch persistent shouldFilterRows />
                </ToolbarContent>
              </Toolbar>
              <svelte:fragment slot="cell" let:cell let:row>
                {#if cell.key === "time"}
                  {formatTimeDelta(cell.value)}
                {:else}
                  {cell.value}
                {/if}
              </svelte:fragment>
            </DataTable>
            <Pagination
              dark
              pageSize={10}
              bind:page={webPage}
              totalItems={webapps.length}
              pageSizeInputDisabled
            />
          </div>
        {/if}
      {:else if webapploading}
        Loading
      {:else}
        <div class="table_wrapper">
          <DataTable
            size="short"
            headers={[
              { key: "applicationname", value: "Application" },
              { key: "clearname", value: "Clearname" },
              { key: "time", value: "Time" },
              { key: "keystrokes", value: "Keystrokes" },
              { key: "mouseclicks", value: "Mouseclicks" },
              { key: "nteams", value: "Teams" },
            ]}
            rows={overview}
            sortable
            bind:sortKey
            bind:sortDirection
            batchSelection
            bind:selectedRowIds
            pageSize={10}
            page={appsPage}
          >
            <Toolbar size="sm">
              <ToolbarBatchActions>
                <Button
                  on:click={addDesktopApplications}
                  text="Add Selected to Limitations"
                  kind="secondary"
                />
              </ToolbarBatchActions>
              <ToolbarContent>
                <ToolbarSearch persistent shouldFilterRows />
              </ToolbarContent>
            </Toolbar>
            <svelte:fragment slot="cell" let:cell let:row>
              {#if cell.key === "time"}
                {formatTimeDelta(cell.value)}
              {:else}
                {cell.value}
              {/if}
            </svelte:fragment>
          </DataTable>
          <Pagination
            pageSize={10}
            bind:page={appsPage}
            totalItems={overview.length}
            pageSizeInputDisabled
          />
        </div>
      {/if}
    </div>

    <div class="table_heading">
      <h5>Limitations</h5>
      <div class="info">
        Here you can whitelist applications relevant to your processes
      </div>
    </div>

    <LimitationList editable={!isCompleted} bind:addedApplications />
    <TextArea
      labelText="Message"
      placeholder="Enter a message for the users"
      bind:value={message}
    />

    <TextArea
      labelText="Message"
      placeholder="Enter a message for confirmation"
      bind:value={confirmmessage}
    />

    {#if !isCompleted}
      <Button
        text="Start Anonymization Recording"
        kind="secondary"
        on:click={startAnonymizationRecording}
      />
    {/if}
  </div>
</SectionWrapper>

<style>
  .main {
    max-width: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .content_wrapper {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .table_heading {
    display: flex;
    flex-direction: column;
    width: 100%;
    background-color: #fc8b5d;
    color: var(--pax-white);
    border-left: 0.6rem solid var(--pax-orange);
    padding: 0.6rem 1rem;
    border-radius: 0.5rem;
  }

  .info_wrapper {
    background: var(--pax-black);
    border-left: 0;
    color: white;
  }
</style>
